import React from 'react';
import "./About.css";
export default function About(){
    return(
<div className='about-container'>
<h1 className='about-heading'>ABOUT ME</h1>
<div className='about-detail'>
Recently trained Full Stack Developer from IIT Madras incubated company-GUVI with a passion for coding. I know to create web applications from start to finish point and deploying it simultaneously. I am looking forward to join forces with frontend and backend technologies to 
develop my skillset while contributing towards a better digitalized tomorrow. I am sincere, trustworthy and love to work on new challenges as I am eager to know about new technologies.
</div>
</div>
    );
}